var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "final_vereinfacht",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e40045;}.cls-2{fill:#303c49;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MAN MapUpdate-8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.71,41.33,38,44V42.1a6.1,6.1,0,0,0,4.31-10.41l-1.08,1.08A4.57,4.57,0,0,1,38,40.57v-1.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.29,30.67,38,28v1.9a6.1,6.1,0,0,0-4.31,10.41l1.08-1.08A4.57,4.57,0,0,1,38,31.43v1.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29,36a8.76,8.76,0,0,1,.23-2H21l0-4.66,2.33-3.11,6.07,2.6,1.47,1.69a9.54,9.54,0,0,1,1.39-1.45l-1.66-1.9-6.86-2.94L22.08,20.8a3.47,3.47,0,0,0,1.35-2.14L29.81,18l8,4H41v5.52a9,9,0,0,1,3,1.79V10a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2V38a2,2,0,0,0,2,2H30A9,9,0,0,1,29,36Zm2-25H41v9H38.24l-8-4-1.27.12L31,13.33ZM7,11H29v1.67l-2.78,3.7-3,.3a3.47,3.47,0,0,0-5.9-.9L13,13.91,7,16.48Zm14.5,7A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,21.5,18ZM8,38a1,1,0,1,1,1-1A1,1,0,0,1,8,38Zm9,0H12a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Zm2-4H7V31l6.09-2,5.9.85Zm-6.05-7L7,28.91V18.66l6-2.57,3.54,1.51a2.71,2.71,0,0,0,0,.4A3.5,3.5,0,0,0,20,21.5l.18,0,1.65,3.41-2.28,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManUpdate);
export default __webpack_public_path__ + "static/media/MAN_Update.9d29e45e06866a9ea1f6318e1be2955c.svg";
export { ForwardRef as ReactComponent };